<template>
  <div style="padding: 16px">
    <div style="width: 100%; display: flex;" v-if="!is_new">
      <button class="button del-button" @click="delete_template">削除</button>
    </div>
    <div style="margin-bottom: 16px;">
      テンプレート名
      <input class="input" type="text" v-model="title"/>
    </div>
    登録する項目
    <div class="tab-box disp-scroll">
      <div v-for="(column) in companyColumnSetting" v-if="!column.is_delete">
        <b-checkbox v-model="selected_columns[column.pk]">{{ column.name }}</b-checkbox>
      </div>
    </div>
    <div style="margin-top: 5px" class="footer-box">
      <button class="button is-primary" @click="save" :disabled="title==''">
        保存
      </button>
      <button class="button" @click="close">
        キャンセル
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    is_new: {
      type: Boolean,
      required: true
    },
    template: {
      type: Object,
      required: false
    },
    filter_columns: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapState('auth', ['companyColumnSetting']),
  },
  mounted() {
    if (this.is_new) {
      // 新規テンプレート作成
      this.selected_columns = this.companyColumnSetting.reduce((obj, column) => {
        obj[column.pk] = this.filter_columns[column.pk] || false
        return obj
      }, {})
    }
    else {
      // テンプレート編集
      this.title = this.template.name
      this.selected_columns = this.template.columns.reduce((obj, column_pk) => {
        obj[column_pk] = true
        return obj
      }, {})
    }
  },
  data() {
    return {
      title: "",
      selected_columns: {},
    }
  },
  methods: {
    delete_template() {
      if (confirm('このテンプレートを削除します。\nよろしいですか？')) {
        this.$store.dispatch('directtalk/deleteSeekerExportTemplate', this.template.id)
        this.$emit('close')
      }
    },
    save() {
      if (this.is_new) {
        this.$store.dispatch('directtalk/createSeekerExportTemplate', {
          name: this.title,
          columns: Object.keys(this.selected_columns).filter((key) => this.selected_columns[key])
        })
      }
      else {
        this.$store.dispatch('directtalk/updateSeekerExportTemplate', {
          id: this.template.id,
          data: {
            name: this.title,
            columns: Object.keys(this.selected_columns).filter((key) => this.selected_columns[key])
          }
        })
      }
      this.$emit('close')
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>

.del-button {
  margin-left: auto;
  height: 24px;
  width: 64px;
}

.tab-box {
  background: white;
  border: solid thin #ccc;
  border-radius: 8px;
  height: 400px;
  padding: 16px;
}

.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/organisms/modals/ModalSeekerExportTemplate.vue